<template>
    <div class="teacherInfo">
        <div class="bottomBorder">
            <!--img :src="teacher.avatarURL" width="80px"
                 height="80px"
                 style="border-radius: 80px; float: left;margin-right:10px"
            /-->
            <div class="hello">
                Xin chào {{gender}} <label class="primaryColor">{{teacher.teacherName}}</label>
            </div>
            <div class="content" v-if="$store.state.auth.user.role==1">Trường/Trung tâm giảng dạy: {{teacher.workingAt}}</div>
            <!--div>
                {{teacher.countClass}} {{$t("lang.class.title")}}
            </div>
            <div>
                {{teacher.countStudent}} {{$t("lang.class.student")}}
            </div-->
        </div>
        <!--div class="bottomBorder">
            <div class="titleInfo">
                <v-icon>business_center</v-icon>
                {{$t('lang.teacher.experience')}}
            </div>
            <div class="valueInfo">
                {{teacher.experience}} {{$t('lang.common.year')}}
            </div>

        </div>
        <div style="padding: 10px">
            <div class="titleInfo">
                <v-icon>menu_book</v-icon>
                {{$t('lang.teacher.workingAt')}}
            </div>
            <div class="valueInfo">
                {{teacher.workingAt}}
            </div>
        </div-->

    </div>
</template>

<script>
    import {message} from '../../services';
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios"
    import IUpload from "../../components/form/Upload";

    export default {
        name: "teacher-info",
        components: {
            IUpload,
            IDatepicker,
        },

        computed:{
            gender: function(){
                if(this.$store.state.auth.user.gender == "true" || this.$store.state.auth.user.gender == true){
                    return "thầy";
                } else {
                    return "cô";
                }
            }
        },

        data() {
            return {
                teacher: []
            }
        },

        created() {
            axios.post(process.env.VUE_APP_API_URL + "/class/teacherInfo").then(
                data => {
                    this.teacher = data;
                    this.teacher.avatarURL = process.env.VUE_APP_API_URL + "/download/attach/" + this.teacher.avatarId;
                },
                error => {
                    //console.log(error);
                }
            )
        },

        methods: {}
    };
</script>
